import { LoginForm } from "components/LoginForm";
import { loginStates } from "../../EmbeddedForm.hook";
import { Link } from "react-router-dom";

export const LoginWindow = ({
  setState,
  setError,
  loading,
  setLoading,
  reloadAuthData,
}) => {
  const isDev = process.env.REACT_APP_CURRENT_ENV === "dev";

  const cancelCallback = () => {
    setState(loginStates.INFO);
  };

  return (
    <div className="flex-1 flex flex-col-reverse md:flex-row justify-center items-center gap-2">
      <div className="flex-1 flex flex-col items-center justify-between gap-6">
        <div
          className={`p-4 sm:p-8 flex flex-col gap-4 rounded-xl border border-solid
            border-gray-300 shadow-lg min-w-80 sm:min-w-96`}
        >
          <LoginForm
            loading={loading}
            reloadButtons={reloadAuthData}
            setError={setError}
            setLoading={setLoading}
            horizontal
            cancelCallback={cancelCallback}
            title="Log in"
            comment={"to your Referral Stream account."}
          />
        </div>
        <div className="text-xs sm:text-sm flex flex-row flex-wrap justify-center items-center gap-2">
          Don't have an account?{" "}
          <Link
            to={`https://app${
              isDev ? "-dev" : ""
            }.referral-stream.com/sign_up/sender`}
            target="_blank"
          >
            <span className="text-blue-900">Register</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
